import { createContext } from 'react'

import { FreeTextsStateContextValue } from './FreeTextsStateContext.types'

export const FreeTextsStateContext = createContext<FreeTextsStateContextValue | undefined>(undefined)
